import styled from 'styled-components';
import {
  screenSize,
  inputBorderColor,
  whiteColor,
  mediumFont,
  boldFont,
} from '@app/styles';
import Logo from '@app/assets/images/munitechlogo.png';

type NavProps = {
  active?: boolean;
};
type Props = {
  disabled?: boolean;
  fromEditPage?: boolean;
  fromDetailsPage?: boolean;
};
export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 100px);
  width: 100%;
  margin-top: 100px;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
    height: calc(100vh - 116px);
    margin-top: 116px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (${screenSize.desktop}) {
    flex-direction: row;
  }
`;
export const MapContainer = styled.div`
  margin: 16px 0px;
  width: 100%;
  min-height: 160px;
  @media (${screenSize.desktop}) {
    width: 50%;
  }
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
      pointer-events:none;
      input{
        background:#edeff3;
      }
      `;
    }
  }}
`;
export const SideNav = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    width: 290px;
    height: 100%;
    overflow-y: hidden;
    overflow-x: hidden;
    border-right: 1px solid ${inputBorderColor};
  }
`;
export const ListView = styled.div`
  width: 100%;
  height: 100%;
  dispaly: flex;
  flex-direction: column;
  padding: 0 15px;
  background-color: ${whiteColor};
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 290px);
    padding: 0 15px 0px 0px;
  }
`;
export const ListContainer = styled.div`
  width: 100%;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    padding: 0px 0px 20px 40px;
  }
`;

export const MunicipalityContainer = styled.div`
  margin-top: 26px;
  @media (${screenSize.tablet}) {
    margin-top: 26px;
  }
`;
export const CheckListContainer = styled.div`
  margin-top: 20px;
  @media (${screenSize.tablet}) {
    margin: 0;
  }
`;

//start of payment pop up css

export const PaymentDueContainer = styled.div`
  padding: 20px 10px;
  margin-bottom: 80px;
  @media (${screenSize.tablet}) {
    padding: 0px 0px 30px 0px;
  }
  ${({ fromDetailsPage }: Props) => {
    if (fromDetailsPage) {
      return `
     margin-bottom:0px;
      `;
    }
  }}
`;

export const PaymentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomButtonContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-right: 40px;
  }
`;
//end of payment pop up css

export const CheckListBox = styled.div`
  margin-top: 20px;
  @media (${screenSize.tablet}) {
    margin-top: 24px;
  }
`;
export const PropertyContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 35px;
  }
`;
export const DocumentContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 35px;
  }
`;

export const Notes = styled.div`
  max-width: 600px;
  position: relative;
  background: #fafbfc;
  border: 1px solid #dee0e8;
  border-radius: 2px;
  line-height: 24px;
  color: #3a435e;
  padding: 5px;
`;

export const BuyerContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 10px;
  }
`;
export const SellerContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 26px;
  }
`;

export const ProUserContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 26px;
  }
`;

export const InvolvedContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 26px;
  }
`;
export const Seperator = styled.div`
  border-bottom: 1px solid #dee0e8;
  margin: 4px 0px 15px 0px;
  @media (${screenSize.tablet}) {
    margin: 4px 80px 26px 0px;
  }
`;
export const PrimarySeperator = styled.div`
  background-color: #e4e6eb;
  border: 0.5px solid #e4e6eb;
  @media (${screenSize.tablet}) {
    margin: 22px 80px 0px 0px;
  }
`;

export const SecondarySeperator = styled.div`
  background-color: #e4e6eb;
  border: 1px solid #e4e6eb;
  @media (${screenSize.tablet}) {
    margin: 24px 80px 26px 0px;
  }
`;
export const MunicipalityBox = styled.div`
  margin-top: 10px;
  @media (${screenSize.tablet}) {
    margin-top: 8px;
  }
`;
export const PropertyBox = styled.div`
  margin-top: 10px;
  @media (${screenSize.tablet}) {
    margin-top: 10px;
  }
`;

export const InputContainer = styled.div`
  @media (${screenSize.tablet}) {
    margin-top: 24px;
  }
`;

export const TotalPriceNote = styled.div`
  color: rgb(81, 81, 81);
  opacity: 0.5;
  margin-top: -15px;
  margin-bottom: 20px;
`;

export const SelectItem = styled.div`
  width: 100%;
  margin-bottom: 20px;
  @media (${screenSize.tablet}) {
    width: 302px;
    margin: 0;
  }
`;

export const PersonTypeCard = styled.div`
  width: 100%;
  margin-bottom: 24px;
  @media (${screenSize.tablet}) {
    width: 302px;
  }
`;

export const ProfessionalUserType = styled.div`
  width: 100%;
  margin-bottom: 12px;
  @media (${screenSize.tablet}) {
    width: 302px;
  }
`;

export const AutoCompleteInput = styled.div`
  position: relative;
  ${({ disabled }: Props) => {
    if (disabled) {
      return `
      pointer-events:none;
      input{
        background:#edeff3;
      }
      `;
    }
  }}
`;
export const InvolvedHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  @media (${screenSize.tablet}) {
    flex-direction: row;
  }
`;

export const InputCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 302px;
    margin-right: 30px;
  }
`;
export const ProUserInput = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    width: 302px;
    margin-right: 30px;
  }
`;

export const StateInputCard = styled.div`
  width: 100%;
  margin-bottom: 20px;
  @media (${screenSize.tablet}) {
    width: 302px;
    margin-bottom: 0;
    margin-right: 30px;
    min-height: 90px;
  }
`;

export const PrimaryInputCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 242px;
    margin-right: 30px;
  }
`;
export const MlsLink = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 580px;
    margin-right: 30px;
  }
`;
export const AddressInputCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 562px;
    margin-right: 30px;
  }
`;
export const SecondaryInputCard = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 580px;
    margin-right: 30px;
  }
`;
export const SelectLabel = styled.label`
  color: #0f1d2a;
  text-align: left;
  line-height: 21px;
  font-size: 15px;
  opacity: 0.5;
  ${mediumFont};
`;
export const Star = styled.label`
  font-size: 15px;
  color: red;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
export const PrimarySelectLabel = styled.label`
  color: #4d505d;
  text-align: left;
  line-height: 21px;
  font-size: 15px;
  ${boldFont};
`;
export const ButtonText = styled.span`
  font-size: 15px;
  color: #ce2424;
  line-height: 24px;
  margin-right: 24px;
  ${mediumFont};
  cursor: pointer;
`;
export const Heading = styled.div`
  font-size: 15px;
  color: #5a606c;
  ${mediumFont};
  margin-bottom: 15px;
  @media (${screenSize.tablet}) {
    margin: 0px;
  }
`;
export const InfoBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
`;
export const EntityContainer = styled.div`
  margin-bottom: 10px;
  ${InfoBox}
`;
export const InputBox = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;
  }
`;

export const CheckBoxContainer = styled.div`
  display: flex;
`;

export const Right = styled.div`
  margin-left: 12px;
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  @media (${screenSize.tablet}) {
    margin: 0;
  }
`;
export const PrimaryInfoBox = styled.div`
  width: 100%;
  position: relative;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 6px;
  }
`;

export const Title = styled.div`
  font-size: 18px;
  color: #d63763;
  line-height: 24px;
  font-style: normal;
  @media (${screenSize.tablet}) {
    padding: 0;
  }
  ${({ fromEditPage }: Props) => {
    if (fromEditPage) {
      return `
      font-size: 16px;
      color: #110f1f;
      line-height: 24px;
      font-family: Noto Serif;
      font-style: normal;
      font-weight: 700;
      `;
    }
  }}
`;

export const NavItem = styled.div`
  @media (${screenSize.tablet}) {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 40px;
    padding-right: 13px;
    cursor: pointer;
    border-bottom: 1px solid ${inputBorderColor};
  }
`;
export const NavText = styled.div`
  cursor: pointer;
  font-size: 15px;
  color: #110f1f;
  ${({ active }: NavProps) => {
    if (active) {
      return `
        color: #D63763;
      `;
    }
  }}
`;
export const ErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin: 0;
  margin-top: -15px;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;
export const SelectErrorMessage = styled.p`
  font-size: 14px;
  color: #ec4160;
  margin-top: 5px;
  bottom: -22px;
  @media (${screenSize.tablet}) {
    bottom: 0;
  }
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
export const MunitechLogo = styled.div`
  width: 30px;
  height: 30px;
  position: absolute;
  margin-left: 10px;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${Logo});
`;

export const SaveButtonBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0px 15px;
  height: 70px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #f4f5f7;
  border-top: 1px solid ${inputBorderColor};
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ButtonItem = styled.div`
 display: block;
    width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
     button{
           height:40px;
          }
    ${({ disabled }: Props) => {
      if (disabled) {
        return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
      }
    }}
  
  @media (${screenSize.tablet}) {
    display:none;
  }
    
`;

export const CancelButton = styled.div`
  display: block;
  cursor: pointer;
  font-size: 15px;
  margin-right: 20px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  margin-left: 8px;
`;

export const ProDropDown = styled.div`
  position: absolute;
  z-index: 2;
  padding: 16px;
  background-color: #fff;
  box-shadow: 0 11px 20px 0 rgb(47 54 65 / 50%);
`;

export const ProUserName = styled.div`
  font-size: 15px;
  margin: 12px 0px;
  cursor: pointer;
`;
